module.exports = __webpack_public_path__ + "static/img/player_head_10045.88bcd9e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/user/player_head_10045.png
// module id = eGj0
// module chunks = 1